import { Button, Grid } from '@mui/material'
import React, { useState } from 'react'
import CustomTypography from '../customComponent/CustomTypography'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import useStyles from './styles';
import CustomTextField from '../customComponent/CustomTextField';
import CountrySelect from './CountrySelect';
import { Countries } from '../../assets/jsonData/countries';
import { axiosClient } from '../../services/axiosClient';

const UserDetails = ({user,setUser,setUserObj,setonuserUpdated,setMessage,setOpenSnackBar,userObj,history,stores,setStore,imagename,image, onImageChanged, onuserUpdated,loggedin,t,deviceType,setUsercountryscope,getRecentProductsByscope,username}) => {
       const classes = useStyles()
     const [countries] = useState(Countries);
      const[showEdit]=useState( true);
      const[visibility,setVisiblity]=useState(deviceType === 'mobile'?false:true)
      const [firstname, setFirstname] = useState(user?.firstname || "");
        const [lastname, setLastname] = useState(user?.lastname || "");
        const [email, setEmail] = useState(user?.email || "");
        const [phone, setPhone] = useState(user?.phone || "");
        const [state, setState] = useState(user.address?.state || "");
        const [city, setCity] = useState(user?.address?.city || "");
        const [street, setStreet] = useState(user?.address?.street || "");
        const [aprt_suit_num, setApt_suit_num] = useState(user?.address?.aprt_suit_num || "");
        const [selectedCountry, setSelectedCountry] = useState(countries.find((country) => country.name === user?.address?.country ||""));



const handleUpdate=(e)=>{
    e.preventDefault();
    editUser().then((response)=>{
        if(response.status===200){
             setUserObj(response.data)
                setUser(response.data.user)
            
             localStorage.setItem('user',JSON.stringify(response.data));
           
            setMessage({body:'user updated successfully',severity:'success'})
            setVisiblity(!visibility)
            setOpenSnackBar(true)             
            setonuserUpdated(!onuserUpdated);
            if (onImageChanged){
                UploadStoreImage(image).then((response) => {
                    if (response.data.status===200){
               setMessage({body:'user image updated',severity:'success'})
               setOpenSnackBar(true) 
                    
              }
                    //addToast(exampleToast(response.data.message));
                })
            }
           // history.push('/new-store')

         }else{
             setMessage({body:'oops something happens',severity:'success'})
            setOpenSnackBar(true) 
            }
       

    });
}

const handleOpenStorePage = ()=>{
  setStore(stores[0]);
  history.push('/my-store')

}
const UploadStoreImage = (file) => {
//const url = process.env.STORE_URL;

const formData = new FormData();
  formData.append('imagename',imagename);
  formData.append('image', file);

  const config = {
    headers: {
        'Content-Type':'application/json',
        'auth-token': user.auth_token,
      },timeout: 20000, withCredentials: true,credentials: "include"
     
      
} 

return axiosClient.post(`${process.env.REACT_APP_SERVER_URL}/user/updateImage/${user._id}`, formData, config)
}

const editUser =()=>{
 
const url = `${process.env.REACT_APP_SERVER_URL}/user/${user._id}`;
     let address={
       country:selectedCountry.name,
       state:state,
       city:city,
       street:street,
       aprt_suit_num:aprt_suit_num
     }
const body={
         userId:user._id,
         username:username.toLowerCase(),
         email:email,
         firstname:firstname,
         lastname:lastname,
         phone:phone,
         address:address,
         imagename:imagename
}
const config = {
    headers: {
        'auth-token':
          user.auth_token,
      },
}
return axiosClient.patch(url, body,config)

};


  return (
      <Grid item xs={12} sm={4} md={12} lg={12} xl={12} marginTop={2}>
 
     {
          loggedin ==='true'  && showEdit ? <Grid container  className={`${classes.userUpdatWrapper} cardOutlined`}> 

           <Grid item xs={12} >
             {loggedin ==="true" ? <Grid container justifyContent='space-between' spacing={1} sx={{padding:{xs:1,md:1,lg:2}}}>
            <Grid item xs={8}>
               <CustomTypography variant='body1' color='GrayText'>{t("account.info")}</CustomTypography>
               </Grid>

             <Grid item xs={4}className={classes.editbar}  onClick={()=>{
              setVisiblity(!visibility)
            }}>
              <Grid container justifyContent='flex-end'  >
             <Grid item  > { 
              visibility ? <Visibility color='textDark'/> : <VisibilityOff color='textDark'/> 
              }</Grid>
              </Grid>
              
               </Grid>
            
            </Grid> :''}
           </Grid>
         
          
          {
            visibility ? <Grid container  marginTop={1}className="user-pdateLft" justifyContent={'space-between'} >
                 <Grid item xs={12} >
                  <form  className="client-userUpdateForm" onSubmit={handleUpdate}>
         
                         <Grid container justifyContent='space-between' spacing={2}
                         sx={{spacing:{xs:1,md:1,lg:2},padding:{xs:1,md:1,lg:2}}}
                         >
                           {/* <div className="
                        -userUpdateItem">
                            <label>UserName</label>
                            <input type="text" required placeholder="mardiaabu33" className="_userUpdateInput" onChange={(e)=>{setUsername(e.target.value)}} value={username}/>
                        </div> */}
            <Grid item xs={12} className="
            -userUpdateItem">
              
                <CustomTextField fullWidth
                placeholder={t("form.account.firstname.label")}
                  variant='outlined' 
                  color='primary'
                  type="text" required  
                /*  onFocus={()=>{handleFocus()}}
                 onBlur={()=>{handleBlur()}} */
               /*  placeholder="Mardia" */ className="_userUpdateInput" onChange={(e)=>{setFirstname(e.target.value)}} value={firstname}/>
            </Grid>
            <Grid item xs={12} className="
            -userUpdateItem">
                
                <CustomTextField 
                placeholder={t("form.account.lastname.label")}
                fullWidth variant='outlined' type="text" color='primary' required /* placeholder=" Abubakari" */ className="_userUpdateInput" onChange={(e)=>{setLastname(e.target.value)}} value={lastname}/>
            </Grid>
            <Grid item xs={12} className="
            -userUpdateItem">
                
                <CustomTextField 
                fullWidth
                placeholder={t("form.account.email.label")}
                 variant='outlined' color='primary' type="email" sx={{fontSize:'0.7rem'}} required /* placeholder="mardiaabu33@gmail.com" */  onChange={(e)=>{setEmail(e.target.value)}} value={email}
                  
                 />
            </Grid>
            <Grid item xs={12} className="
            -userUpdateItem">
               
                <CustomTextField placeholder={t("form.account.phone.label")} fullWidth variant='outlined' color='primary' type="number" required /* placeholder="+23358473829"  */className="_userUpdateInput" onChange={(e)=>{setPhone(e.target.value)}} value={phone}/>
            </Grid>
            <Grid item xs={12} className="
            -userUpdateItem">
                <label>{t("form.account.country.label")}</label>

                {/* <CustomTextField  variant='outlined' type="text" required placeholder="Ghana" className="_userUpdateInput" onChange={(e)=>{setCountry(e.target.value)}} value={country}/> */ }

                <CountrySelect required variant='outlined'  setOpen={()=>{}} selectedCountry={selectedCountry} setSelectedCountry={setSelectedCountry} allOptions={countries} 
                setUsercountryscope={setUsercountryscope} Label='Country' getRecentProductsByscope={getRecentProductsByscope}/>    
            </Grid>
            <Grid item xs={12} className="
            -userUpdateItem">
               {/*  <label>{t("form.account.state.label")}</label> */}
                <CustomTextField fullWidth variant='outlined' type="text" color='primary' required placeholder={t("form.account.state.label")}className="_userUpdateInput" onChange={(e)=>{setState(e.target.value)}} value={state}/>
            </Grid>
            <Grid item xs={12}className="
            -userUpdateItem">
               
                <CustomTextField
                placeholder={t("form.account.city.label")}
                fullWidth variant='outlined' color='primary' type="text" required /* placeholder="Tamale" */ className="_userUpdateInput" onChange={(e)=>{setCity(e.target.value)}} value={city}/>
            </Grid>
            <Grid item xs={12} className="
            -userUpdateItem">
             
                <CustomTextField placeholder={t("form.account.street.label")} fullWidth color='primary'  variant='outlined' required /* placeholder="Nsung naa st" */ className="_userUpdateInput" onChange={(e)=>{setStreet(e.target.value)}} value={street}/>
            </Grid>
            <Grid item xs={12} className="
            -userUpdateItem">
                <CustomTextField fullWidth
                 placeholder={t("form.account.apartment.label")}
                 variant='outlined' type="text" primary='primary' /* placeholder="apertment No,Hno eg E343"  */className="_userUpdateInput" 
                /*  onFocus={()=>{handleFocus()}}
                 onBlur={()=>{handleBlur()}} */
                onChange={(e)=>{setApt_suit_num(e.target.value)}} value={aprt_suit_num}/>
               </Grid>                    
            
            {
            <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}  >
                     <Button type='submit' fullWidth /* disabled={stores.length >0 ? true :false} */ variant='outlined' color='primary'>{t("form.account.buttonupdate.label")}</Button>
                  {/* 
                     stores &&  stores.length > 0 ? '':<Grid item xs={12}  >
                     <Button type='submit' fullWidth disabled={stores.length >0 ? true :false} variant='outlined' color='primary'>{t("form.account.buttonupdate.label")}</Button>
                  */
                  }
                   </Grid> 
                </Grid>
            </Grid>
            }
                          </Grid> 
                      

              </form>
                  
                  
                  </Grid>
              </Grid>:''
          }
                  
           
                </Grid>   :''
        }
</Grid>
  )
}

export default UserDetails
